import { createRaster, type Raster, RGBA_CHANNELS } from './raster';

/** 픽셀 하나의 직선 RGBA. */
export type Rgba = readonly [number, number, number, number];

const WHITE: Rgba = [255, 255, 255, 255];
const BLACK: Rgba = [0, 0, 0, 255];

/**
 * 체크무늬 래스터. cell px 칸마다 흰색과 검정이 번갈아 오고 왼쪽 위 칸은 흰색이다. 모두 불투명하다.
 * 행은 두 가지(첫 칸이 흰색인 행과 검정인 행)뿐이라 한 번씩 만든 뒤 행마다 복사한다.
 */
export function checkerPattern(width: number, height: number, cell: number): Raster {
  if (!Number.isInteger(cell) || cell <= 0) {
    throw new RangeError(`체크무늬 칸 크기 ${cell} 가 양의 정수가 아니다`);
  }
  const raster = createRaster(width, height);
  const whiteFirst = checkerRow(width, cell, true);
  const blackFirst = checkerRow(width, cell, false);
  for (let y = 0; y < height; y += 1) {
    const row = Math.floor(y / cell) % 2 === 0 ? whiteFirst : blackFirst;
    raster.data.set(row, y * width * RGBA_CHANNELS);
  }
  return raster;
}

function checkerRow(width: number, cell: number, startsWhite: boolean): Uint8ClampedArray {
  const row = new Uint8ClampedArray(width * RGBA_CHANNELS);
  for (let x = 0; x < width; x += 1) {
    const isWhite = (Math.floor(x / cell) % 2 === 0) === startsWhite;
    row.set(isWhite ? WHITE : BLACK, x * RGBA_CHANNELS);
  }
  return row;
}

/** 모든 픽셀이 같은 RGBA 인 래스터. */
export function solidRaster(width: number, height: number, rgba: Rgba): Raster {
  const raster = createRaster(width, height);
  for (let offset = 0; offset < raster.data.length; offset += RGBA_CHANNELS) {
    raster.data.set(rgba, offset);
  }
  return raster;
}
